import React, { useEffect } from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";
import { useLocation } from "react-router-dom";
import "./App.css";

import Homepage from "./pages/Homepage";
import About from "./pages/About";
import Mercury from "./pages/Mercury";
import Venus from "./pages/Venus";
import Earth from "./pages/Earth";
import Mars from "./pages/Mars";
import Jupiter from "./pages/Jupiter";
import Saturn from "./pages/Saturn";
import Navigation from "./Navigation";
import PlanetList from "./PlanetList";
import List from "./pages/List";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Route path="/about" component={About} />
        <Route path="/mercury" component={Mercury} />
        <Route path="/venus" component={Venus} />
        <Route path="/earth" component={Earth} />
        <Route path="/mars" component={Mars} />
        <Route path="/jupiter" component={Jupiter} />
        <Route path="/saturn" component={Saturn} />
        <Route path="/planet_list" component={PlanetList} />
        <Route path="/list" component={List} />
        <Route path="/" component={Homepage} />
        <Navigation />
      </div>
    </Router>
  );
}

export default App;
